module.exports = __webpack_public_path__ + "static/media/Clumsy Guy.9b4812da.jpg";